var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.56435 5.37395L5.98573 6.79534L10.7237 2.05738",
    stroke: "#BDBABB",
    strokeWidth: 0.947592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2498 5.84773V9.1643C10.2498 9.41562 10.15 9.65665 9.97228 9.83435C9.79457 10.0121 9.55355 10.1119 9.30223 10.1119H2.66909C2.41777 10.1119 2.17675 10.0121 1.99904 9.83435C1.82133 9.65665 1.7215 9.41562 1.7215 9.1643V2.53116C1.7215 2.27984 1.82133 2.03882 1.99904 1.86111C2.17675 1.6834 2.41777 1.58357 2.66909 1.58357H7.88084",
    stroke: "#BDBABB",
    strokeWidth: 0.947592,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_45"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.3711,
    height: 11.3711,
    fill: "white",
    transform: "translate(0.300171 0.16217)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.47640311089135a3c5307aa2e3cdedb2.svg";
export { ForwardRef as ReactComponent };